import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6501a4c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-card-games" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = {
  key: 0,
  class: "content"
}
const _hoisted_4 = {
  key: 1,
  class: "text-only"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "image" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "card" }
const _hoisted_9 = {
  key: 0,
  class: "content"
}
const _hoisted_10 = {
  key: 1,
  class: "text-only"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "image" }
const _hoisted_13 = ["src"]

import { withDefaults } from "vue";
import { CardGamesSchema } from "@/schemas/common";
import { getImage, getTranslate } from "@/utils";
import { CardImageText } from "@/components";


export default /*#__PURE__*/_defineComponent({
  __name: 'ListCardGames',
  props: {
    items: null,
    gap: { default: "0.5rem" },
    background: { default: "transparent" },
    imageWidth: { default: "90%" },
    paddingInline: { default: "1rem" },
    paddingBlock: { default: "1rem" },
    margin: { default: "2rem" }
  },
  setup(__props: any) {

const props = __props as { items: CardGamesSchema[], gap: string, background: string, imageWidth: string, paddingInline: string, paddingBlock: string, margin: string };

_useCssVars(_ctx => ({
  "1f2f3420": (__props.paddingInline),
  "01c88b54": (__props.paddingBlock),
  "e4027b88": (__props.gap),
  "1ba3a308": (__props.background),
  "2bccd088": (__props.margin),
  "14968305": (__props.imageWidth)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "item"
      }, [
        _createElementVNode("div", _hoisted_2, [
          (item.left_card.logo || item.left_card.text)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (item.left_card.logo)
                  ? (_openBlock(), _createBlock(_unref(CardImageText), {
                      key: 0,
                      image: item.left_card.logo.path,
                      "image-local": item.left_card.logo.local,
                      "image-width": item.left_card.logo.width,
                      text: item.left_card.text || '',
                      "long-text": false
                    }, null, 8, ["image", "image-local", "image-width", "text"]))
                  : (item.left_card.text)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("p", {
                          innerHTML: _unref(getTranslate)(item.left_card.text)
                        }, null, 8, _hoisted_5)
                      ]))
                    : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: 
              _unref(getImage)(item.left_card.image.path, item.left_card.image.local)
            ,
              alt: "image"
            }, null, 8, _hoisted_7)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (item.right_card.logo || item.right_card.text)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (item.right_card.logo)
                  ? (_openBlock(), _createBlock(_unref(CardImageText), {
                      key: 0,
                      image: item.right_card.logo.path,
                      "image-local": item.right_card.logo.local,
                      "image-width": item.right_card.logo.width,
                      text: item.right_card.text || '',
                      "long-text": false
                    }, null, 8, ["image", "image-local", "image-width", "text"]))
                  : (item.right_card.text)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("p", {
                          innerHTML: _unref(getTranslate)(item.right_card.text)
                        }, null, 8, _hoisted_11)
                      ]))
                    : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("img", {
              src: 
              _unref(getImage)(item.right_card.image.path, item.right_card.image.local)
            ,
              alt: "image"
            }, null, 8, _hoisted_13)
          ])
        ])
      ]))
    }), 128))
  ]))
}
}

})